import { getCurrentUser, isUser } from "@neumetric/blueprint-lib/store";
import {
  getAuditStatusList,
  getAuditState,
  getCurrentAudit,
  getCurrentControl,
} from "./helpers";
import "./saga";
export * from "./slice";

const Priorities = [
  { id: "R0_Critical", label: "Critical", dotIconName: "critical" },
  { id: "R1_High", label: "High", dotIconName: "high" },
  { id: "R2_Medium", label: "Medium", dotIconName: "medium" },
  { id: "R3_Low", label: "Low", dotIconName: "low" },
  { id: "R4_Minimal", label: "Minimal", dotIconName: "minimal" },
  { id: "R5_None", label: "None", dotIconName: "none" },
];

const PrioritiesByScore = [
  { id: "10", label: "Critical [10]" },
  { id: "9", label: "Critical [9]" },
  { id: "8", label: "High [8]" },
  { id: "7", label: "High [7]" },
  { id: "6", label: "Medium [6]" },
  { id: "5", label: "Medium [5]" },
  { id: "4", label: "Low [4]" },
  { id: "3", label: "Low [3]" },
  { id: "2", label: "Minimal [2]" },
  { id: "1", label: "Minimal [1]" },
  { id: "0", label: "None [0]" },
];
export { getCurrentAudit, getCurrentControl, getAuditStatusList };
export const getAuditList = (state) => {
  return getAuditState(state).auditList;
};

export const getCurrentAuditDetails = (state) => {
  return getAuditState(state).currentAuditDetails;
};

export const getPriorities = () => {
  return Priorities;
};

export const getPrioritiesByScore = () => {
  return PrioritiesByScore;
};

export const getPriorityById = (id) => {
  return Priorities.find((priority) => priority.id === id);
};

export const getReportFormatsList = (state) => {
  const _state = getAuditState(state);
  return _state.reportFormats;
};

export const getBlueprintModelsList = (state) => {
  const _state = getAuditState(state);
  return _state.blueprintModels;
};

export const getAuditTypesList = (state) => {
  const _state = getAuditState(state);
  return _state.auditTypes;
};

export const getGovernorsList = (state) => {
  const _state = getAuditState(state);
  return _state.governors;
};

export const getUsersList = (state) => {
  const _state = getAuditState(state);
  return _state.users;
};

export const getCreateReportSuccess = (state) => {
  const _state = getAuditState(state);
  return _state.createReportSuccess;
};

export const getReportList = (state) => {
  const _state = getAuditState(state);
  return _state.reportList;
};

export const getSubscribedBlueprint = (state) => {
  const _state = getAuditState(state);
  return _state.subscribedBlueprintList;
};

export const getModelDetails = (state) => {
  const _state = getAuditState(state);
  return _state.modelDetails;
};

export const getReportFrameworkList = (state) => {
  const _state = getAuditState(state);
  return _state.reportFrameworkList;
};

export const getCurrentReportDetails = (state) => {
  const _state = getAuditState(state);
  return _state.reportDetails;
};

export const getAuditUploadHistory = (state) => {
  const _state = getAuditState(state);
  return _state.auditUploadHistory;
};

export const canUpdateAudit = (state) => {
  const currentUser = getCurrentUser(state);
  const isUserRole = isUser(currentUser);
  const currentAudit = getCurrentAudit(state);
  if (isUserRole) {
    return (
      currentAudit.audit_status === "pending" ||
      currentAudit.audit_status === "revision"
    );
  }
  return currentAudit.audit_status !== "complete";
};

export const isAuditSubmitted = (state) => {
  const currentAudit = getCurrentAudit(state);
  return currentAudit.audit_status.toLowerCase() === "submitted";
};

export const isAuditCompleted = (state) => {
  const currentAudit = getCurrentAudit(state);
  return currentAudit.audit_status.toLowerCase() === "completed";
};

export const shouldDisableAction = (state) => {
  const _state = getAuditState(state);
  return _state.disableAction;
};

export const reportBlueprints = (state) => {
  const _state = getAuditState(state);
  return _state.reportBlueprints;
};
